// extracted by mini-css-extract-plugin
export default {"autoPlaySelector":"AutoPlaySelector_autoPlaySelector__baMYb"};